exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub_t[data-v-4747fa32]{font-size:.18rem;font-weight:bold}.page-btns[data-v-4747fa32]{text-align:center}", ""]);

// exports
